import * as FilePond from "filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

FilePond.registerPlugin(FilePondPluginFileValidateType);
FilePond.registerPlugin(FilePondPluginImagePreview);
FilePond.registerPlugin(FilePondPluginFileValidateSize);

window.FilePond = FilePond;

document.addEventListener("FilePond:loaded", () => {
  const fileponds = document.querySelectorAll(".filepond--root");
  fileponds.forEach((filepond) => {
    filepond.addEventListener("FilePond:updatefiles", (event) => {
      filepond.classList.toggle("has-files", event.detail.pond.getFiles().length > 0);
    });
  });
});
